import { useState } from "react";
import purchaseService from "../services/purchaseService";


/* eslint-disable react/prop-types */
export default function PromotionCodeBox({ cartItems, onApplied }) {
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [applied, setApplied] = useState(false);

    const handleApply = async () => {
        try {
            setLoading(true);
            
            const data = await purchaseService.previewPurchase({
                cartItems,
                promotionCode: code
            });

            setApplied(true);
            onApplied({
                promotionCode: code,
                finalTotal: data.finalTotal,
                discountPercentage: data.discountPercentage
            });
        } catch (error) {
            setApplied(false);
            onApplied(null);

            alert(
                error.response?.data?.message || "Código inválido"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-lg mx-auto p-4 bg-zinc-900 mt-8 rounded-sm">
            <label className="block text-sm mb-2">
                Código de descuento
            </label>

            <div className="flex flex-col gap-2 sm:flex-row">
                <input
                    type="text"
                    value={code}
                    onChange={(e) => {
                        setCode(e.target.value.toUpperCase());
                        setApplied(false);
                        onApplied(null);
                    }}
                    placeholder="PROMO50"
                    className="w-full flex-1 p-2 rounded bg-zinc-800 border border-zinc-700"
                />

                <button
                    onClick={handleApply}
                    disabled={loading || !code}
                    className="w-full bg-yellow-cdg hover:bg-yellow-600 text-black px-4 rounded disabled:opacity-50 sm:w-auto"
                >
                    Aplicar
                </button>
            </div>

            {loading && (
                <p className="text-sm text-zinc-400 mt-2">
                    Validando código...
                </p>
            )}

            {applied && (
                <p className="text-sm text-green-500 mt-2">
                    Código aplicado correctamente ✔
                </p>
            )}
        </div>
    );
}
